// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-zhOqoE","spin":"spin-GmuWQS"};